<template>
  <div class="renewal">
    <div class="app-container">
      <div class="route-container route-container--skinny">
        <h1>Membership Renewal</h1>
        <div class="route-container-inner">
          <div v-if="isStudent">
            <div
              v-if="
                (!expectedQualified.value ||
                  expectedQualified.value === minDate ||
                  expectedQualificationDatePassed) &&
                  !showDateInput
              "
            >
              <p>Are you still a {{ fee.title }}?</p>

              <div class="route-controls">
                <button class="btn" @click="setShowDateInput(true)">
                  Yes
                </button>
                <router-link :to="{ name: 'NewMember' }">No</router-link>
              </div>
            </div>
            <div v-else>
              <p>Please enter your new expected qualified date</p>

              <ValidationObserver ref="form">
                <form-component
                  :page="page"
                  @submit="updateExpectedQualifiedDate"
                />
                <button
                  role="button"
                  class="btn btn--positive"
                  @click="updateExpectedQualifiedDate"
                >
                  Confirm
                </button>
              </ValidationObserver>
            </div>
          </div>
          <div v-else>
            <p>Are you still a {{ fee.title }}?</p>

            <div class="route-controls">
              <router-link :to="{ name: 'Contact Details' }">Yes</router-link>
              <router-link :to="{ name: 'NewMember' }">No</router-link>
            </div>
          </div>
        </div>
      </div>
      <section class="controls">
        <router-link class="ctrl ctrl--begin" :to="{ path: '/profile' }">
          Back
        </router-link>
      </section>
    </div>
    <spinner />
  </div>
</template>

<script>
import FormComponent from "@/components/FormComponent.vue";
import Spinner from "@/components/Spinner";
import { registrationConfig } from "@/helpers/config";
import { doPatch } from "@/helpers/fetch-helper";
import { useMemberDetails } from "@/helpers/member-details";
import { studentCodes } from "@/helpers/membership";
import { useShowSpinner } from "@/helpers/showSpinner";
import { computed, ref } from "@vue/composition-api";
import { ValidationObserver } from "vee-validate";

export default {
  components: {
    ValidationObserver,
    FormComponent,
    Spinner,
  },
  setup(_, ctx) {
    const minDate = "0001-01-01T00:00:00";
    const {
      membershipType,
      membershipStatusType,
      expectedQualified,
    } = useMemberDetails();

    const { setShowSpinner } = useShowSpinner();
    const form = ref(null);
    const page = {
      fields: [
        {
          id: 0,
          type: "date",
          key: "expectedQualified",
          label: "When do you expect to complete your course?",
          value: "",
          rules: ["required"],
          dateConfig: {
            maxDate: new Date().setFullYear(new Date().getFullYear() + 6),
            minDate: new Date().setFullYear(new Date().getFullYear()),
          },
          orderYears: true,
        },
      ],
    };

    const showDateInput = ref(false);
    const setShowDateInput = (val) => {
      showDateInput.value = val;
      return;
    };

    const isStudent = computed(() =>
      studentCodes.includes(membershipStatusType.value),
    );

    const expectedQualificationDatePassed = computed(() => {
      if (!expectedQualified.value || expectedQualified.value === minDate) {
        return false;
      } else {
        return new Date(expectedQualified.value) < new Date();
      }
    });

    const fee = registrationConfig.fees.find(
      (f) =>
        f.memTypeCode === membershipType.value &&
        f.memStatusCode ===
          (membershipStatusType.value === "NP1" ||
          membershipStatusType.value === "NP2"
            ? "ORD"
            : membershipStatusType.value),
    );

    const updateExpectedQualifiedDate = async () => {
      const valid = await form.value.validate();
      if (!valid) return;
      setShowSpinner(true);
      const resp = await doPatch("/education", {
        expectedQualified: page.fields[0].value,
      });
      setShowSpinner(false);
      if (resp.success) {
        expectedQualified.value = page.fields[0].value;
        ctx.root.$router.push({ name: "Contact Details" });
      }
    };

    // still in their student phase
    if (
      expectedQualified.value &&
      expectedQualified.value !== minDate &&
      !expectedQualificationDatePassed.value
    ) {
      ctx.root.$router.push({ name: "Contact Details" });
    }

    if (!membershipType.value || !membershipStatusType.value) {
      ctx.root.$router.push({ name: "NewMember" });
    }

    return {
      membershipType,
      membershipStatusType,
      fee,
      form,
      isStudent,
      expectedQualified,
      expectedQualificationDatePassed,
      minDate,
      showDateInput,
      setShowDateInput,
      page,
      updateExpectedQualifiedDate,
    };
  },
};
</script>

<style lang="scss" scoped>
.route-container-inner {
  padding: 7.5em 2em;
  text-align: center;

  p {
    font-size: 1.125em;
    font-weight: 700;
    line-height: 2em;
  }

  .route-controls {
    margin-left: -1em;

    a,
    .btn {
      display: inline-block;
      color: var(--primary);
      margin-left: 1em;
      background: #fff;
      border: 1px solid var(--primary);
      border-radius: 50px;
      text-align: center;
      width: 8.125em;
      padding: 0.3125em;
      text-decoration: none;
      transition: all 0.4s linear;

      &:hover {
        color: #fff;
        background-color: var(--primary);
      }
    }
  }
}

.controls {
  margin-bottom: 24px;
  text-align: center;

  a {
    color: var(--primary);
    text-decoration: underline;
  }
}
</style>
